import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbDropdownModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';

import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { VerticalComponent } from './vertical/vertical.component';
import { ModernComponent } from './modern/modern.component';
import { ThemeSwitchComponent } from './modern/theme-switch/theme-switch.component';
import { ModernSidebarComponent } from './modern/modern-sidebar/modern-sidebar.component';
import { ModernTopbarComponent } from './modern/modern-topbar/modern-topbar.component';
import { ModernFooterComponent } from './modern/modern-footer/modern-footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { LanguageService } from 'src/app/core/services/language.service';
import { CustomerCreateEditModalModule } from '../components/customers/customer-create-edit-modal/customer-create-edit-modal.module';


@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent, SidebarComponent, TopbarComponent, FooterComponent, HorizontalComponent, VerticalComponent, ModernComponent, ThemeSwitchComponent, ModernSidebarComponent, ModernTopbarComponent, ModernFooterComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    ClickOutsideModule,
    SharedComponentsModule,
    SimplebarAngularModule,
    NgbTypeaheadModule,
    NgSelectModule,
    FormsModule,
    CustomerCreateEditModalModule
  ],
  providers: [LanguageService]
})
export class LayoutsModule { }
